import {
  SidebarMenu,
  SidebarMenuButton,
  SidebarMenuItem,
  useSidebar,
} from "@/components/ui/sidebar";
import { t } from "@lingui/core/macro";
import { Trans } from "@lingui/react/macro";
import { EllipsisVertical, LogOut } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { ResponsiveMenu } from "../responsive/ResponsiveMenu";
import { UserSummary } from "./UserSummary";

const name = "Demo";
const initials = "D";

export function DemoProfile() {
  const { isMobile } = useSidebar();
  const navigate = useNavigate();

  const lastSync = new Date().toISOString();

  return (
    <SidebarMenu>
      <SidebarMenuItem>
        <ResponsiveMenu
          isMobile={isMobile}
          trigger={
            <SidebarMenuButton
              size="lg"
              className="data-[state=open]:bg-sidebar-accent data-[state=open]:text-sidebar-accent-foreground"
              aria-label={t`Open profile menu`}
            >
              <UserSummary
                name={name}
                initials={initials}
                lastSync={lastSync}
                className="flex-1"
              />
              <EllipsisVertical className="ml-auto size-4" aria-hidden="true" />
            </SidebarMenuButton>
          }
          pages={[
            {
              id: "root",
              title: <Trans>Profile</Trans>,
              items: [
                {
                  type: "label",
                  key: "summary",
                  content: (
                    <UserSummary
                      name={name}
                      initials={initials}
                      lastSync={lastSync}
                      className="px-1 py-1.5"
                    />
                  ),
                },
                { type: "separator", key: "sep-1" },

                {
                  type: "action",
                  key: "resync",
                  label: <Trans>Exit demo mode</Trans>,
                  icon: <LogOut className="h-4 w-4" />,
                  onSelect: () => {
                    navigate("/");
                  },
                },
              ],
            },
          ]}
        />
      </SidebarMenuItem>
    </SidebarMenu>
  );
}
